/* Built In Imports */
import NextLink from 'next/link';

/* External Imports */
import { Box, Flex, Link, SimpleGrid } from '@chakra-ui/react';
import { nanoid } from 'nanoid';
import { FaPlay } from 'react-icons/fa';

/* Internal Imports */
/* Components */
import MidContainer from '@eternal/Components/Layout/MidContainer';
import LazyLoadImageComponent from '@eternal/Components/Ui/LazyLoadImageComponent';
import { refineUrlDomain } from '@eternal/Components/Utility/utils';
/* Services */

/**
 * Renders the Card Info 4 Card component
 * @param {Object} sectionContent - Data for section
 * @param {string} region - Region of the page
 * @param {string} lang - Language of the page
 * @returns {ReactElement} CardInfo4 Card component
 */

const CardInfo4 = ({ sectionContent, region, lang }) => {
  return (
    <MidContainer
      w={{ base: 700, xl: 1200 }}
      px={{ base: '10px', md: '20px' }}
      py="0"
    >
      <SimpleGrid
        // columns='2'
        columns={{
          sm: '1',
          md: '2',
          lg: '2',
        }}
        m="auto"
        textAlign="left"
        spacing="15px"
        placeItems="center"
      >
        {sectionContent?.cards?.map((secCon, index) => {
          return (
            <Box
              w={{ base: '100%', sm: '288px', md: 345, xl: '100%' }}
              maxH={{
                base: '290px',
                sm: '344px',
                lg: '530px',
                xl: '585px',
              }}
              maxW={{
                base: '288px',
                sm: '100%',
              }}
              position="relative"
              key={nanoid()}
              overflow="hidden"
            >
              <Flex
                w={{ base: '48px', md: '60px', lg: '80px', xl: '96px' }}
                h={{ base: '48px', md: '60px', lg: '80px', xl: '96px' }}
                position="absolute"
                zIndex="1"
                right="10px"
                bottom="10px"
                background="rgba(45, 44, 44, 0.8)"
                outline="2px solid #C9BAAB"
                color="#C9BAAB"
                outlineOffset={{ base: '-5px', md: '-10px' }}
                padding="5px"
                _hover={{
                  background: '#020202',
                  padding: '10px',
                  outline: '2px solid #fff',
                  outlineOffset: { base: '-8px', md: '-15px' },
                  color: '#fff',
                  transitionDuration: '.7s',
                  transitionTimingFunction: 'ease-in-out',
                }}
              >
                {secCon.buttonLink != '' && (
                  <NextLink
                    href={refineUrlDomain(secCon.buttonLink, region, lang)}
                    passHref
                    legacyBehavior
                  >
                    <Link
                      target={
                        secCon.buttonLink.indexOf('http') > -1
                          ? '_blank'
                          : '_self'
                      }
                      w="100%"
                      display="inline-flex"
                      height="100%"
                      alignItems="center"
                      justifyContent="center"
                    >
                      <FaPlay />
                    </Link>
                  </NextLink>
                )}
              </Flex>
              <Box>
                <NextLink
                  href={refineUrlDomain(secCon.buttonLink, region, lang)}
                  passHref
                  legacyBehavior
                >
                  <Link
                    target={
                      secCon.buttonLink.indexOf('http') > -1
                        ? '_blank'
                        : '_self'
                    }
                  >
                    <LazyLoadImageComponent
                      src={secCon.thumbnail?.url}
                      title={secCon.thumbnail?.title}
                      alt={secCon.thumbnail?.alt}
                      w="100%"
                      h="100%"
                      _hover={{
                        transform: 'scale(1.2)',
                        transformOrigin: 'center',
                        overflow: 'hidden',
                        transitionDuration: '1.5s',
                        transitionTimingFunction: 'ease-in-out',
                        filter: 'brightness(40%)',
                      }}
                    />
                  </Link>
                </NextLink>
              </Box>
            </Box>
          );
        })}
      </SimpleGrid>
    </MidContainer>
  );
};

export default CardInfo4;
